import Button from "@/common/components/Button";
import { ChannelStatus } from "@/common/types/cable/actionCable.type";
import { Link2Icon, Link2OffIcon } from "lucide-react";

interface CableStatusProps {
  status: ChannelStatus;
}

const CableStatus = ({ status }: CableStatusProps) => {
  if (status === ChannelStatus.Connecting || status === ChannelStatus.Idle) {
    return (
      <Button
        variant="yellow"
        className="disabled:opacity-100 h-10"
        disabled
        isLoading
      >
        Conectando
      </Button>
    );
  }

  if (status === ChannelStatus.Rejected) {
    return (
      <Button
        variant="yellow-black"
        className="disabled:opacity-100 h-10"
        disabled
      >
        Tempo real indisponível

        <Link2OffIcon
          strokeWidth={1.5}
          size={20}
        />
      </Button>
    );
  }

  if (status === ChannelStatus.Disconnected) {
    return (
      <Button
        variant="yellow-black"
        className="disabled:opacity-100 h-10"
        disabled
      >
        Desconectado

        <Link2OffIcon
          strokeWidth={1.5}
          size={20}
        />
      </Button>
    );
  }

  return (
    <Button
      variant="outline-disabled"
      className="disabled:opacity-100 text-white-400 border border-white-200 h-10"
      disabled
    >
      Conectado

      <Link2Icon
        strokeWidth={1.5}
        size={20}
      />
    </Button>
  );
}

export default CableStatus;
